import React from "react";

import {
    Stack,
    Text,
    Box,
    Divider,
    SimpleGrid,
} from "@chakra-ui/react";

import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";



const getYouTubeEmbedUrl = (url) => {

    if (!url) {
        return "";
    }

    try {

        const parsedUrl = new URL(url);

        let videoId = "";


        if (
            parsedUrl.hostname.includes(
                "youtube.com"
            )
        ) {

            videoId =
                parsedUrl.searchParams.get(
                    "v"
                ) || "";

        }


        if (
            parsedUrl.pathname.startsWith(
                "/shorts/"
            )
        ) {

            videoId =
                parsedUrl.pathname
                    .split("/shorts/")[1]
                    .split("/")[0]
                    .split("?")[0];

        }


        if (
            parsedUrl.pathname.startsWith(
                "/embed/"
            )
        ) {

            videoId =
                parsedUrl.pathname
                    .split("/embed/")[1]
                    .split("/")[0]
                    .split("?")[0];

        }


        if (
            parsedUrl.hostname.includes(
                "youtu.be"
            )
        ) {

            videoId =
                parsedUrl.pathname
                    .replace("/", "")
                    .split("?")[0];

        }


        if (!videoId) {
            return "";
        }


        return `https://www.youtube.com/embed/${videoId}`;

    } catch (error) {

        console.error(
            "Invalid YouTube URL:",
            error
        );

        return "";

    }
};


const ViewAgentTraining = ({
    training,
}) => {

    if (!training) {

        return (
            <Text color="gray.500">
                No training information available.
            </Text>
        );

    }


    return (

        <Stack spacing={5}>

      
            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Title
                </Text>

                <Text fontWeight="600">
                    {training.title || "N/A"}
                </Text>

            </Box>


            <Divider />


            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Description
                </Text>

                <Text>
                    {training.description || "N/A"}
                </Text>

            </Box>


            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Training Content
                </Text>

                <Text
                    whiteSpace="pre-wrap"
                >
                    {training.content || "N/A"}
                </Text>

            </Box>


            <Divider />



            <SimpleGrid
                columns={2}
                spacing={5}
            >

                {/* STATUS */}

                <Box>

                    <Text
                        fontSize="sm"
                        color="gray.500"
                        mb={2}
                    >
                        Status
                    </Text>

                    <StatusBadge
                        label={
                            training.status ||
                            "N/A"
                        }
                        variant={
                            getStatusVariant(
                                training.status
                            )
                        }
                    />

                </Box>


                {/* MANDATORY */}

                <Box>

                    <Text
                        fontSize="sm"
                        color="gray.500"
                        mb={2}
                    >
                        Mandatory
                    </Text>

                    <StatusBadge
                        label={
                            training.mandatory
                                ? "Yes"
                                : "No"
                        }
                        variant={
                            training.mandatory
                                ? "success"
                                : "gray"
                        }
                    />

                </Box>

            </SimpleGrid>


            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Display Order
                </Text>

                <Text fontWeight="600">
                    {
                        training.display_order ??
                        "N/A"
                    }
                </Text>

            </Box>


            <Divider />



            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={2}
                >
                    Training Video
                </Text>

                {training.video_url ? (

                    <Box
                        position="relative"
                        width="100%"
                        paddingBottom="56.25%"
                        borderRadius="md"
                        overflow="hidden"
                        bg="black"
                    >

                        <Box
                            as="iframe"
                            position="absolute"
                            top="0"
                            left="0"
                            width="100%"
                            height="100%"
                            src={
                                getYouTubeEmbedUrl(
                                    training.video_url
                                )
                            }
                            title={
                                training.title ||
                                "Agent Training Video"
                            }
                            border="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />

                    </Box>

                ) : (

                    <Box
                        borderWidth="1px"
                        borderRadius="md"
                        p={4}
                    >

                        <Text
                            color="gray.500"
                            fontSize="sm"
                        >
                            No video provided.
                        </Text>

                    </Box>

                )}

            </Box>


            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Training Material
                </Text>

                {training.material_url ? (

                    <Box
                        borderWidth="1px"
                        borderRadius="md"
                        p={4}
                    >

                        <Text
                            color="blue.500"
                            cursor="pointer"
                            onClick={() =>
                                window.open(
                                    training.material_url,
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        >
                            Open Training Material
                        </Text>

                    </Box>

                ) : (

                    <Text
                        color="gray.500"
                        fontSize="sm"
                    >
                        No material provided.
                    </Text>

                )}

            </Box>


            <Box>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={1}
                >
                    Date Created
                </Text>

                <Text fontWeight="600">

                    {training.created_at
                        ? new Date(
                            training.created_at
                        ).toLocaleDateString()
                        : "N/A"}

                </Text>

            </Box>

        </Stack>

    );

};


export default ViewAgentTraining;